import script from "./PrecosComerciaisCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./PrecosComerciaisCadastro.vue?vue&type=script&setup=true&lang=js"

import "./PrecosComerciaisCadastro.vue?vue&type=style&index=0&id=e4f9a93c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4f9a93c"]])

export default __exports__